export default __webpack_public_path__ + "static/media/nebula.17a6ddf8.svg";